import logo from '../assets/images/ishema_logo_light.png'
import {Link, NavLink, useLocation, useNavigate} from "react-router-dom";
import {LoginAnimatedButton} from "./misc";
import { LuMenu } from "react-icons/lu";
import { HiXMark } from "react-icons/hi2";
import {useEffect, useState} from "react";
import {useAppDispatch, useAppSelector} from "../store";
import {useWhoamiQuery} from "../api/auth";
import {storage} from "../utils";
import {userSlice} from "../store/slices/userSlice";
import { campaign } from "../config/campaign";
import { isEventSalesClosed } from "../utils";

export default function MainHeader() {
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { user } = useAppSelector((state) => state.userState);
    const dispatch = useAppDispatch();
    const nextTicketStop =
        campaign.stops.find(
            (stop) => !isEventSalesClosed({ endDate: stop.isoDate, status: "active" })
        ) ?? campaign.stops[0];
    const nav_links = [
        {
            title: 'Tour',
            location: ''
        },
        {
            title: 'Tickets',
            location: `event/${nextTicketStop.slug}`
        },
        {
            title: 'Contact',
            location: 'contact-us'
        },
        {
            title: 'My Tickets',
            location: 'tickets'
        },

    ];

    const { isError, isLoading } = useWhoamiQuery(null, {
        skip: !storage.getToken(),
        refetchOnMountOrArgChange: true,
    });

    useEffect(() => {
        if (isError) {
            storage.removeToken();
            navigate('/');
        }
    }, [isError, navigate]);

    useEffect(() => {
        setOpen(false);
    }, [pathname]);

    const logOut = () => {
        storage.removeToken();
        dispatch(userSlice.actions.logout())
    }
    return (
        <div className="sticky top-0 z-40 border-b border-white/10 bg-[#120202]/95 text-white backdrop-blur">
            <nav className={'flex flex-row justify-between items-center w-full px-4 py-3 md:px-12'}>
                <div className={'flex w-full flex-col md:flex-row items-center md:justify-between md:gap-10'}>
                    <div className="flex flex-row justify-between w-full md:w-auto">
                        <Link to="/" className="flex items-center gap-3">
                            <img src={logo} alt={'ISHEMA TICKETS'} className={'w-10'}/>
                            <div className="leading-tight">
                                <p className="text-sm font-black uppercase tracking-[0.24em] text-[#ffb45f] sm:text-base">
                                    Igitangaza
                                </p>
                            </div>
                        </Link>

                        <button onClick={() => setOpen(prev => !prev)} className={"md:hidden"}>
                            {open ? <HiXMark className={'text-3xl'}/> : <LuMenu className={'text-3xl'}/>}
                        </button>
                    </div>

                    {<ul className={`w-full ${open ? 'flex' : 'hidden'} transition-all md:flex md:w-auto items-center flex-col md:flex-row gap-5 pt-5 md:pt-0`}>
                        {nav_links.map((item, index) => <li key={index} className={'text-sm font-black uppercase tracking-[0.12em] text-white/70 transition hover:text-[#ffb45f]'}><NavLink
                            to={`/${item.location}`}>{item.title}</NavLink></li>)}
                        {user ? <li onClick={() => logOut()} className={'cursor-pointer text-sm font-black uppercase tracking-[0.12em] text-[#ffb45f]'}>Log Out</li> : isLoading ? <div className={'h-10 w-24 animate-pulse rounded-md bg-white/10'}></div> : <LoginAnimatedButton/>}
                    </ul>}
                </div>

            </nav>
        </div>
    )
}
